<kyc-header />
@if (!internalUserError) {
  @if (isLoggedIn && !isLoading()) {
    <router-outlet />
  } @else {
    <div class="m-5 flex items-center justify-center"><nx-spinner size="large" /></div>
  }
}
